/* eslint-disable ember/classic-decorator-hooks */
import BaseMain from '../../implementation-common/base-main';
import PieWedge from '../../implementation-common/base-pie-wedge';
import BigHugeCircuitGroupCommon from './big-huge-circuit-group';
import * as ReverseImplementation from './reverse-implementation';

export default class FirstOrderCommonMain extends BaseMain {
  bigHugeCircuitGroupModel;
  reverseImplementation;
  init() {
    this.bigHugeCircuitGroupModel = BigHugeCircuitGroupCommon;
    this.reverseImplementation = ReverseImplementation;
  }

  getInterestingCircuits(commercialCircuit, toleranceInput) {
    var pieWedgeTable = [];
    var bigHugeCircuitGroup = this.bigHugeCircuitGroupModel.create({
      circuit: commercialCircuit,
      toleranceInput: toleranceInput,
    });
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -90,
        range: 10,
        explanatoryText: 'Low fps',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 90,
        range: 10,
        explanatoryText: 'High fps',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );

    var result = pieWedgeTable.map((pieWedge) => {
      return pieWedge.interestingCircuit;
    });
    return result;
  }
}
